import colors from '@theme/colors';

export const MuiLink = {
  styleOverrides: {
    root: {
      '&.MuiLink-root ': {
        fontFamily: 'Proxima Nova',
        fontWeight: 700,
        lineHeight: '1',
      },
    },
  },
  variants: [
    {
      props: { color: 'primary' },
      style: {
        color: colors.SEAFOAM_SUPPLEMENTAL,
      },
    },
  ],
};
